class CookieConsent {
  constructor() {
    this.cookieName = 'cookie_consent';
    this.cookieExpiry = 365;
    this.init();
  }

  init() {
    const consent = this.getCookie(this.cookieName);

    if (!consent) {
      this.showConsent();
    } else if (consent === 'accepted') {
      this.loadCookies();
    }

    document.getElementById('cookie-accept')?.addEventListener('click', () => this.acceptCookies());
    document.getElementById('cookie-reject')?.addEventListener('click', () => this.rejectCookies());
  }

  showConsent() {
    const consentBox = document.getElementById('cookie-consent');
    if (!consentBox) return;

    consentBox.style.display = 'block';
    window.setTimeout(() => {
      consentBox.style.opacity = '1';
      consentBox.style.transform = 'translateY(0)';
    }, 10);
  }

  hideConsent() {
    const consentBox = document.getElementById('cookie-consent');
    if (!consentBox) return;

    consentBox.style.opacity = '0';
    consentBox.style.transform = 'translateY(100%)';
    window.setTimeout(() => {
      consentBox.style.display = 'none';
    }, 300);
  }

  acceptCookies() {
    this.setCookie(this.cookieName, 'accepted', this.cookieExpiry);
    this.loadCookies();
    this.hideConsent();
  }

  rejectCookies() {
    this.setCookie(this.cookieName, 'rejected', this.cookieExpiry);
    this.removeCookies();
    this.hideConsent();
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/;SameSite=Lax`;
  }

  getCookie(name) {
    const prefix = `${name}=`;
    const cookies = document.cookie.split(';');

    for (const item of cookies) {
      const cookie = item.trim();
      if (cookie.startsWith(prefix)) return cookie.substring(prefix.length);
    }

    return null;
  }

  loadCookies() {
    if (typeof window.gtag !== 'undefined') {
    }
  }

  removeCookies() {
    const essential = new Set([this.cookieName, '_shopify_y', '_shopify_s']);

    for (const item of document.cookie.split(';')) {
      const separator = item.indexOf('=');
      const name = (separator > -1 ? item.slice(0, separator) : item).trim();
      if (essential.has(name)) continue;

      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
    }
  }
}

(() => {
  const runWhenIdle = (callback) => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 1800 });
    } else {
      window.setTimeout(callback, 700);
    }
  };

  const getAssetBase = () => {
    const script = document.currentScript || document.querySelector('script[src*="cookie-consent.js"]');
    if (!script?.src) return '';
    return script.src.replace(/cookie-consent\.js(\?.*)?$/, '');
  };

  const loadStylesheet = (fileName) => {
    const base = getAssetBase();
    if (!base || document.querySelector(`link[href*="${fileName}"]`)) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${base}${fileName}`;
    document.head.appendChild(link);
  };

  const initialize = () => {
    runWhenIdle(() => new CookieConsent());
    runWhenIdle(() => {
      [
        'choice-deferred-cookie-consent.css',
        'choice-deferred-list-social.css',
        'choice-deferred-pinch-zoom.css',
      ].forEach(loadStylesheet);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();

(() => {
  const body = document.body;
  if (!body.classList.contains('template-index')) return;

  let ticking = false;

  const announcementHeight = () => {
    const sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader) return 0;

    let height = 0;
    let sibling = sectionHeader.previousElementSibling;

    while (sibling) {
      if (sibling.classList.contains('shopify-section-group-header-group')) {
        const rect = sibling.getBoundingClientRect();
        if (rect.height > 0) height += rect.height;
      }
      sibling = sibling.previousElementSibling;
    }

    return Math.round(height);
  };

  const update = () => {
    const height = announcementHeight();
    body.style.setProperty('--choice-announcement-height', `${height}px`);
    const threshold = Math.max(12, height - 1);
    body.classList.toggle('choice-header-solid', window.scrollY >= threshold);
    ticking = false;
  };

  const schedule = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  update();
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', update);
  document.addEventListener('shopify:section:load', schedule);
})();

(() => {
  const label = 'WhatsApp ile iletişime geç';
  const selector = 'a[href*="api.whatsapp.com/send"], a[href*="wa.me/"], a[href*="whatsapp.com/send"]';
  let scheduled = false;

  const labelLinks = () => {
    scheduled = false;
    document.querySelectorAll(selector).forEach((link) => {
      if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', label);
      if (!link.getAttribute('title')) link.setAttribute('title', label);

      if (link.target === '_blank') {
        const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
        rel.add('noopener');
        rel.add('noreferrer');
        link.setAttribute('rel', Array.from(rel).join(' '));
      }
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(labelLinks);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelLinks, { once: true });
  } else {
    labelLinks();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
